import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TEMPLATE = "GET_LIST_TEMPLATE";
export const GET_DETAIL_TEMPLATE = "GET_DETAIL_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const DELETE_FILE_PSD = "/api/templates";
export const SET_LIST_TEMPLATE = "SET_LIST_TEMPLATE";
export const SET_DETAIL_TEMPLATE = "SET_DETAIL_TEMPLATE";
export const GET_TEMPLATE_BY_COPY = "GET_TEMPLATE_BY_COPY";
export const SET_TEMPLATE_BY_COPY = "SET_TEMPLATE_BY_COPY";
export const GET_LIST_TEMPLATE_BY_SEARCH = "GET_LIST_TEMPLATE_BY_SEARCH";
export const SET_LIST_TEMPLATE_BY_SEARCH = "SET_LIST_TEMPLATE_BY_SEARCH";
export const UPLOAD_DESIGN_TEMPLATE = "/admin/upload/psd-2";
export const EDIT_DESIGN_TEMPLATE = "/admin/update-template-template-size";


const state = {
    templates: [],
    templateDetail: {},
    templateBySearch: [],
    templateCopy: {},
    totalTemplate:0
};

const getters = {
    templates(state) {
        return state.templates;
    },
    templateDetail(state) {
        return state.templateDetail;
    },
    templateBySearch(state) {
        return state.templateBySearch;
    },
    templateCopy(state) {
        return state.templateCopy;
    },
    totalTemplate(state) {
        return state.totalTemplate;
    },
};

const actions = {
    [GET_LIST_TEMPLATE](context,payload) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TEMPLATE}`,payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TEMPLATE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TEMPLATE](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TEMPLATE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TEMPLATE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_TEMPLATE_BY_COPY](context, id) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_TEMPLATE_BY_COPY}`, id).then(({data}) => {
                if (data.status) {
                    context.commit(SET_TEMPLATE_BY_COPY, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_TEMPLATE_BY_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_LIST_TEMPLATE_BY_SEARCH}`, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TEMPLATE_BY_SEARCH, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TEMPLATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TEMPLATE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TEMPLATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPDATE_TEMPLATE}/${payload.id}?_method=PUT`, payload.payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TEMPLATE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TEMPLATE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_DESIGN_TEMPLATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPLOAD_DESIGN_TEMPLATE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_FILE_PSD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${DELETE_FILE_PSD}/${payload.template_id}/template-sizes`, payload.template_size_id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [EDIT_DESIGN_TEMPLATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${EDIT_DESIGN_TEMPLATE}/${payload.template_id}`, payload.data)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TEMPLATE](state, data) {
        state.templates = data.data.data;
        state.totalTemplate = data.data.total;
    },
    [SET_DETAIL_TEMPLATE](state, data) {
        state.templateDetail = data.data;
    },
    [SET_LIST_TEMPLATE_BY_SEARCH](state, data) {
        state.templateBySearch = data.data;
    },
    [SET_TEMPLATE_BY_COPY](state, data) {
        state.templateCopy = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};